import React, { useEffect, useState } from 'react';
import MostrarOrden from '../ui/mostrarOrden';

const API_BASE = process.env.REACT_APP_API_BASE;


const Ordenes = () => {
  const [pendientes, setPendientes] = useState([]);
  const [enProceso, setEnProceso] = useState([]);
  const [enRuta, setEnRuta] = useState([]);

  useEffect(() => {
    const fetchOrdenes = async () => {
      try {
        // Consulta las tres categorías a la vez
        const [pendResp, procResp, rutaResp] = await Promise.all([
          fetch(`${API_BASE}/api/ordenes?estado=Pendiente`),
          fetch(`${API_BASE}/api/ordenes?estado=enProceso`),
          fetch(`${API_BASE}/api/ordenes?estado=enRuta`),
        ]);
        const pendientesData = await pendResp.json();
        const enProcesoData = await procResp.json();
        const enRutaData = await rutaResp.json();
        setPendientes(Array.isArray(pendientesData) ? pendientesData : []);
        setEnProceso(Array.isArray(enProcesoData) ? enProcesoData : []);
        setEnRuta(Array.isArray(enRutaData) ? enRutaData : []);
      } catch (error) {
        setPendientes([]);
        setEnProceso([]);
        setEnRuta([]);
        console.error('Error al obtener órdenes:', error);
      }
    };

    fetchOrdenes();
    // Si quieres refrescar cada X segundos:
    // const interval = setInterval(fetchOrdenes, 8000);
    // return () => clearInterval(interval);
  }, []);


  return (
    <div className="p-4 max-w-6xl mx-auto">
      <h1 className="text-4xl font-bold mb-6 text-center">Órdenes</h1>
      {/* Pendientes */}
      <section className="mb-10">
        <h2 className="text-2xl font-semibold mb-4 text-yellow-700">Órdenes Pendientes</h2>
        {pendientes.length === 0 ? (
          <p className="text-gray-500">No hay órdenes pendientes.</p>
        ) : (
          pendientes.map((orden) => (
            <MostrarOrden key={orden.id} orden={orden} />
          ))
        )}
      </section>

      {/* En Proceso */}
      <section className="mb-10">
        <h2 className="text-2xl font-semibold mb-4 text-blue-700">Órdenes en Proceso</h2>
        {enProceso.length === 0 ? (
          <p className="text-gray-500">No hay órdenes en proceso.</p>
        ) : (
          enProceso.map((orden) => (
            <MostrarOrden key={orden.id} orden={orden} />
          ))
        )}
      </section>

      <section className="mb-10">
        <h2 className="text-2xl font-semibold mb-4 text-green-700">Órdenes en Ruta</h2>
        {enRuta.length === 0 ? (
          <p className="text-gray-500">No hay órdenes en ruta.</p>
        ) : (
          enRuta.map((orden) => (
            <MostrarOrden key={orden.id} orden={orden} />
          ))
        )}
      </section>

    </div>
  );
};

export default Ordenes;
